<template>
  <div>
    <template>
      <div>
        <naj-alert type="alert">
          <template slot="content">
            <strong class="h6 font-weight-black">
              {{ locale.bankruptDebts.note }}
            </strong>
          </template>
        </naj-alert>
      </div>
    </template>
    <div class="d-flex justify-content-between">
      <strong class="h5 font-weight-black">
        {{ locale.list }} {{ locale.bankruptDebts.tabTitle }}

      </strong>
      <div>
        <naj-button
          color="primary"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDebtsConfirmation}`] && isNotCompleted)"
          @click="addNewHandler"
        >
          <v-icon
            left
            v-text="`mdi-plus`"
          ></v-icon>
          {{ local.common.add }}
        </naj-button>
        <!-- <naj-button
          color="primary"
          @click="importDataHandler"
        >
          {{ locale.importData }}
        </naj-button> -->
      </div>
    </div>

    <div>
      <p>
        {{ locale.bankruptDebts.totalCount }}
        <strong class="totalCount">
          {{ pagination.totalCount ? pagination.totalCount : 0 }}
        </strong>

        {{ locale.bankruptDebts.totalCountDebt }}
        <strong class="totalCount">
          {{ totalSum ? totalSum : 0 }}
        </strong>

        {{ locale.bankruptDebts.totalCountDebtGuaranteed }}
        <strong class="totalCount">
          {{ totalSumGuaranteed ? totalSumGuaranteed : 0 }}
        </strong>
      </p>
    </div>
    <div>
      <slot />
    </div>
    <div>
      <v-row>
        <v-col>
          <naj-item-table
            :data-items="bankruptDebts.list"
            :headers="headers"
            :pagination="pagination"
            :loading="loading"
            :items-per-page="pagination.pageSize"
            :server-items-length="pagination.totalCount"
            :enable-expand="false"
            @update:page="onPageChange"
          >
            <template
              slot="actionEdit"
              slot-scope="{item}"
            >
              <naj-button
                :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDebtsConfirmation}`] && isNotCompleted)"
                outlined
                @click="showUpdateModal(item)"
              >
                {{ local.common.update }}
              </naj-button>
            </template>
            <template
              slot="actionDelete"
              slot-scope="{item}"
            >
              <naj-button
                :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.partnersConfirmation}`] && isNotCompleted)"
                type="button"
                color="error"
                outlined
                @click="showPopupRemove(item)"
              >
                {{
                  local.common.remove
                }}
              </naj-button>
            </template>
          </naj-item-table>
        </v-col>
      </v-row>
    </div>
    <naj-modal
      ref="bankruptDebtModal"
      :title="isEditMode? `${local.common.update} ${locale.bankruptDebts.bankruptDebt}` : `${local.common.add} ${locale.bankruptDebts.bankruptDebt}`"
      :width="1200"
      show-footer-close-button
      @onClose="onCloseModal"
    >
      <v-form ref="addForm">
        <bankrupt-debts-form
          :form-model="formModel"
          :loading="loading"
          :is-edit-mode="isEditMode"
          :request-owner-type-id="requestOwnerTypeId"
        >
          ></bankrupt-debts-form>
      </v-form>
      <template slot="actions">
        <naj-button
          :loading="loading"
          @click="submit"
        >
          {{ isEditMode? local.common.update :local.common.add }}
        </naj-button>
      </template>
    </naj-modal>
    <naj-confirmation
      :show-modal="showRemovePopup"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.common.removeConfirmationMessage"
      :ok-btn-label="local.common.remove"
      @ok="removeBankruptDebts"
      @cancel="showRemovePopup = false"
    ></naj-confirmation>
  </div>
</template>

<script>
import BankruptDebtsForm from './bankrupt-debts-form.vue';
import { createNamespacedHelpers } from 'vuex';
import { toHijriDate } from '@/helpers/utils';
import { mainRequestAuditFlag, requestStatusEnum } from '@/modules/bankruptcy/helpers/enum';
const { mapActions, mapGetters, mapState } = createNamespacedHelpers('BankruptcyModule');

export default {
  components: { BankruptDebtsForm },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
      default: '',
    },
    requestOwnerTypeId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      toHijriDate,
      formModel: {},
      loading: false,
      bankruptDebts: { list: [] },
      totalCount: 0,
      totalSum: 0,
      totalSumGuaranteed: 0,
      headers: [
        {
          value: 'index',
          text: this.local.bankruptcy.requestDetails.sequence,
        },
        {
          value: 'name',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.name,
        },
        {
          value: 'remainingPayment',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.debtValue,
        },
        {
          value: 'dueDate',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.dueDate,
          formatter: toHijriDate,
        },
        {
          value: 'actionEdit',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
        {
          value: 'actionDelete',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },

      ],
      pagination: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      isEditMode: false,
      mainRequestAuditFlag,
      requestStatusEnum,
      showRemovePopup: false,
      selectedItem: {},
    };
  },
  computed: {
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isNotCompleted',
    ]),
    ...mapState({ auditConfirmations: state => state.auditConfirmations }),
  },
  mounted() {
    this.pagination.pageIndex = 0;
    this.loadData();
  },
  methods: {
    ...mapActions(['submitAddNewBankruptDebt', 'getBankruptDebtsByRequestObjectKey', 'getBankruptDebt', 'updateBankruptDebt', 'deleteBankruptDebt']),
    addNewHandler() {
      this.$refs.bankruptDebtModal.show();
    },
    importDataHandler() { },
    loadData() {
      this.loading = true;
      this.totalSum = 0;
      this.totalSumGuaranteed = 0;
      this.getBankruptDebtsByRequestObjectKey({
        requestObjectKey: this.requestObjectKey,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.loading = false;
          this.bankruptDebts = { ...data };
          this.bankruptDebts.list.forEach((element, index) => {
            element.index = index + 1 + (this.pagination.pageSize * this.pagination.pageIndex);
          });

          if (this.bankruptDebts.list.length) {
            this.totalSum = this.bankruptDebts.list[0].totalSum;
            this.totalSumGuaranteed = this.bankruptDebts.list[0].totalSumGuaranteed;
          }
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });

    },
    onPageChange(pageIndex) {
      this.pagination.pageIndex = pageIndex - 1;
      this.loadData();
    },
    showPopupRemove(item) {
      this.showRemovePopup = true;
      this.selectedItem = item;
    },
    removeBankruptDebts() {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: this.selectedItem.objectKey,
      };
      this.loading = true;
      this.deleteBankruptDebt(params)
        .then(() => {
          this.loadData();
          this.toaster.success(this.local.bankruptcy.common.removeSuccessfully);
        })
        .finally(() => {
          this.loading = false;
          this.showRemovePopup = false;
        });
    },

    submit() {
      if (this.$refs.addForm)
        this.$refs.addForm.$validator.validateAll().then((valid) => {
          if (valid) {
            this.loading = true;
            this.formModel.requestObjectKey = this.requestObjectKey;
            const method = this.formModel.objectKey ? 'updateBankruptDebt' : 'submitAddNewBankruptDebt';
            this[method]({
              requestObjectKey: this.requestObjectKey,
              ...this.formModel,
            })
              .then(() => {
                const message = this.formModel.objectKey ? 'updateSuccessfully' : 'addedSuccessfully';
                this.$refs.bankruptDebtModal.close();
                this.loadData();
                this.toaster.success(this.local.bankruptcy.common[message]);
              })
              .finally(() => { this.loading = false; });
          }
        });
    },
    showUpdateModal(model) {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: model.objectKey,
      };
      this.loading = true;
      this.getBankruptDebt(params)
        .then((res) => {
          this.formModel = res.data;
          this.isEditMode = true;
          this.$refs.bankruptDebtModal.show();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetForm() {
      this.$refs.addForm.$validator.reset();
    },
    onCloseModal() {
      for (const key in this.formModel)
        if (Object.hasOwnProperty.call(this.formModel, key))
          this.$set(this.formModel, key, undefined);
      this.isEditMode = false;
      this.resetForm();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: #faf9f4 0% 0% no-repeat padding-box;
}
.totalCount {
  padding: 6px;
  margin-right: 2px;
  margin-left: 13px;
  background-color: black;
  font-size: 13px;
  color: white;
}
div p {
  font-size: 15px;
}
</style>
